// Gmail Connection
export const GMAIL_CONNECTION_STATUS_REQUEST = "GMAIL_CONNECTION_STATUS_REQUEST";
export const GMAIL_CONNECTION_STATUS_SUCCESS = "GMAIL_CONNECTION_STATUS_SUCCESS";
export const GMAIL_CONNECTION_STATUS_FAIL = "GMAIL_CONNECTION_STATUS_FAIL";

export const GMAIL_CONNECT_REQUEST = "GMAIL_CONNECT_REQUEST";
export const GMAIL_CONNECT_SUCCESS = "GMAIL_CONNECT_SUCCESS";
export const GMAIL_CONNECT_FAIL = "GMAIL_CONNECT_FAIL";

export const GMAIL_DISCONNECT_REQUEST = "GMAIL_DISCONNECT_REQUEST";
export const GMAIL_DISCONNECT_SUCCESS = "GMAIL_DISCONNECT_SUCCESS";
export const GMAIL_DISCONNECT_FAIL = "GMAIL_DISCONNECT_FAIL";

// Scan Gmail Inbox
export const SCAN_GMAIL_INBOX_REQUEST = "SCAN_GMAIL_INBOX_REQUEST";
export const SCAN_GMAIL_INBOX_SUCCESS = "SCAN_GMAIL_INBOX_SUCCESS";
export const SCAN_GMAIL_INBOX_FAIL = "SCAN_GMAIL_INBOX_FAIL";
export const SCAN_GMAIL_INBOX_STATUS_UPDATE = "SCAN_GMAIL_INBOX_STATUS_UPDATE";

// List Staged ITBs
export const LIST_STAGED_ITBS_REQUEST = "LIST_STAGED_ITBS_REQUEST";
export const LIST_STAGED_ITBS_SUCCESS = "LIST_STAGED_ITBS_SUCCESS";
export const LIST_STAGED_ITBS_FAIL = "LIST_STAGED_ITBS_FAIL";

// Import ITBs
export const IMPORT_ITBS_REQUEST = "IMPORT_ITBS_REQUEST";
export const IMPORT_ITBS_SUCCESS = "IMPORT_ITBS_SUCCESS";
export const IMPORT_ITBS_FAIL = "IMPORT_ITBS_FAIL";
export const IMPORT_ITBS_STATUS_UPDATE = "IMPORT_ITBS_STATUS_UPDATE";

// Reject ITB
export const REJECT_ITB_REQUEST = "REJECT_ITB_REQUEST";
export const REJECT_ITB_SUCCESS = "REJECT_ITB_SUCCESS";
export const REJECT_ITB_FAIL = "REJECT_ITB_FAIL";

// ITB Selection
export const ITB_SELECT = "ITB_SELECT";
export const ITB_SELECT_ALL = "ITB_SELECT_ALL";
export const ITB_DESELECT_ALL = "ITB_DESELECT_ALL";
export const ITB_CLEAR_SELECTION = "ITB_CLEAR_SELECTION";

// Filter
export const ITB_SET_FILTER = "ITB_SET_FILTER";

// Messages
export const ITB_SET_SUCCESS_MESSAGE = "ITB_SET_SUCCESS_MESSAGE";
export const ITB_SET_ERROR_MESSAGE = "ITB_SET_ERROR_MESSAGE";
export const ITB_CLEAR_MESSAGES = "ITB_CLEAR_MESSAGES";

